<template>
  <section ref="darkBg" :class="['personality-dark', progressClass]">
    <div
      ref="darkImgWrap"
      class="personality-dark__screens--wrap wow textInPartMotion"
      :data-wow-offset="screensOffsetH5"
      data-wow-duration="0.4s"
      data-wow-delay="0.3s"
    >
      <div
        :class="[
          'personality-dark__screens-type screen-motion',
          {
            'screen-motion1': currentType === 1,
            'screen-motion2': currentType === 2
          }
        ]"
        @touchstart="handleTouchStart"
        @touchend="handleTouchEnd"
      >
        <template v-for="n in 3">
          <img
            :key="n"
            ref="screens"
            :src="require(`../../assets${vm.lang === 'zh' ? '/zh' : ''}/personality/personality-dark-screens-${n}.png`)"
            class="personality-dark__screens"
            alt="ColorOS 11 暗色模式"
          />
        </template>
        <div
          ref="screen4"
          class="personality-dark__screens personality-dark__screens-last"
          @transitionend="handleTransitionEnd"
        >
          <img
            v-lazy="
              require(`../../assets${vm.lang === 'zh' ? '/zh' : ''}/personality/personality-dark-screens-4-1.png`)
            "
            alt="ColorOS 11 暗色模式"
          />
          <div ref="artPlaceholder" class="personality-dark__screens-gentle-placeholder">
            <img
              ref="screenLast"
              v-lazy="require('../../assets/personality/personality-art-screen.jpg')"
              class="art-screen-placeholder"
              alt="我是占位图片 ColorOS 11 Art+ 壁纸"
            />
          </div>
          <img
            v-lazy="
              require(`../../assets${vm.lang === 'zh' ? '/zh' : ''}/personality/personality-dark-screens-4-2.png`)
            "
            alt="ColorOS 11 暗色模式"
          />
          <img
            v-lazy="
              require(`../../assets${vm.lang === 'zh' ? '/zh' : ''}/personality/personality-dark-screens-4-3.png`)
            "
            alt="ColorOS 11 暗色模式"
          />
        </div>
      </div>
      <img
        ref="artScreen"
        v-lazy="require('../../assets/personality/personality-art-screen.jpg')"
        class="personality-dark__art"
        alt="ColorOS 11 Art+ 壁纸"
      />
    </div>
    <div class="personality-dark__text--wrap">
      <div ref="darkTextWrap" v-textMotion="textOffset" class="personality-dark__text text-intro">
        <div class="title">{{ $t('personality-dark-title') }}</div>
        <div class="sub-title">{{ $t('personality-dark-sub-title') }}</div>
        <div id="dark-description" class="description">{{ $t('personality-dark-description') }}</div>
        <div>
          <div class="progress-text">
            <span :class="{ actived: currentType === 0 }" @click="handleMobileChange(0)">
              {{ $t('personality-dark-type-1') }}
            </span>
            <span :class="{ actived: currentType === 1 }" @click="handleMobileChange(1)">
              {{ $t('personality-dark-type-2') }}
            </span>
            <span :class="{ actived: currentType === 2 }" @click="handleMobileChange(2)">
              {{ $t('personality-dark-type-3') }}
            </span>
          </div>
          <div class="progress-bar">
            <div ref="progressLine" :class="['progress-line', progressClass]"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
export default {
  inject: ['vm'],
  data() {
    return {
      progressClass: 'progress-line-0',
      darkType: ['gentle', 'middle', 'strong'],
      currentType: 0,
      scene: null,
      isLastTransitionEnd: false,
      screensOffsetH5: screen.availHeight / 2 - 270
    };
  },
  computed: {
    textOffset() {
      return this.vm.isMobile ? false : window.innerHeight / 2 - 60;
    }
  },
  watch: {
    currentType(newValue, oldValue) {
      this.$parent.darkType = newValue;
      // 从2到别的状态置为false
      if (oldValue === 2) {
        this.isLastTransitionEnd = false;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initScene();
    });
    // window.addEventListener('resize', () => {
    //   this.setArtPosition();
    // });
  },
  methods: {
    handleTransitionEnd() {
      if (this.currentType === 2 && !this.vm.isMobile) {
        this.isLastTransitionEnd = true;
      }

      window.addEventListener('resize', () => {
        this.setArtPosition();
      });
    },
    initScene() {
      //定住暗色模式模块
      this.scene = new ScrollMagic.Scene({
        duration: this.vm.isMobile ? 10010 : 1200,
        triggerElement: '.personality-dark',
        triggerHook: 0,
        offset: 0
      })
        .setPin('.personality-dark')
        .addTo(Controller);
      //处理滚动过程中的细节
      this.scene.on('progress', event => {
        !this.vm.isMobile && this.handleDarkTransition(event);
      });
      this.scene.on('start', () => {
        this.vm.isMobile && Controller.scrollTo(this.scene);
        this.pageOffset = document.documentElement.scrollTop;
        // 在暗色模块刷新后，js触发文字进场
        let textDoms = Array.from(this.$refs.darkTextWrap.children);
        textDoms.push(this.$refs.darkImgWrap);
        if (textDoms[0].style.visibility !== 'visible') {
          textDoms.forEach(dom => {
            dom.classList.remove('textInPartMotion');
            setTimeout(() => {
              dom.style.visibility = 'visible';
            }, 50);
          });
        }
      });
    },
    //PC端切换，不是连贯动画
    handleDarkTransition(event) {
      if (
        (event.scrollDirection === 'REVERSE' && this.currentType === 0) ||
        (event.scrollDirection === 'FORWARD' && this.currentType === 2)
      )
        return;
      let progress = event.progress * 1200;
      if (progress >= 0 && progress < 300) {
        this.hancleSwitchType(0);
      } else if (progress >= 300 && progress < 600) {
        this.hancleSwitchType(1);
      } else if (progress >= 600 && progress <= 900) {
        this.hancleSwitchType(2);
      }
    },
    setArtPosition() {
      // 设置壁纸元素的位置
      this.$refs.artScreen.style.left = this.$refs.darkImgWrap.clientWidth - this.$refs.screenLast.clientWidth + 'px';
    },
    handleMobileChange(num) {
      if (!this.vm.isMobile) return;
      this.hancleSwitchType(num);
      Controller.scrollTo(this.pageOffset + (9925 / 2) * num);
    },
    hancleSwitchType(num) {
      this.currentType = num;
      this.progressClass = 'progress-line-' + this.currentType;
    },
    handleTouchStart(e) {
      if (!this.vm.isMobile) return;
      this.startTouchY = e.touches[0].pageY;
    },
    handleTouchEnd(e) {
      if (!this.vm.isMobile) return;
      let base = 5;
      let pageY = e.changedTouches[0].pageY;
      let deltaY = pageY - this.startTouchY;

      //往上浏览页面
      if (deltaY > base && this.currentType !== 0) {
        this.handleMobileChange(--this.currentType);
      } else if (deltaY < -base && this.currentType !== 2) {
        this.handleMobileChange(++this.currentType);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.personality-dark {
  height: 100vh;
  display: flex;
  justify-content: flex-start;
  transition: background 1s linear;
  background: #000;
  z-index: 10;
  &__screens--wrap {
    // width: 46.875%;
    position: relative;
  }
  &__screens-type {
    // position: absolute;
    // left: 0px;
    height: 100vh;
    display: flex;
    align-items: flex-start;
    overflow: hidden;
    // width: 35.625vw;
  }
  &__screens {
    width: 150px;
    margin-left: 28px;
    flex-shrink: 0;
    &:nth-child(1) {
      margin-top: -60px;
      margin-left: 0;
    }
    &:nth-child(2) {
      margin-top: -120px;
    }
    &:nth-child(3) {
      margin-top: -90px;
    }
    &:nth-child(4) {
      margin-top: -180px;
    }
  }
  &__screens-last {
    img {
      width: 100%;
      height: 100%;
      border-radius: 14px;
    }
    & > img:last-child {
      margin-top: 24px;
    }
  }
  &__screens-gentle-placeholder {
    height: 330px;
    margin: 24px 0;
  }
  &__text--wrap {
    width: calc(100vw - 715px);
    height: 100%;
    display: flex;
    align-items: center;
    padding-right: 50px;
  }
  &__text {
    margin-left: 215px;
    // width: 465px;
    // margin-top: 472px;
    .title,
    .sub-title {
      color: #fff;
    }
    .description {
      max-width: 587px;
      padding-bottom: 57px;
      color: rgba($color: #fff, $alpha: 0.5);
    }
    .progress-text {
      width: 240px;
      text-align: center;
      margin-bottom: 6px;
      span {
        font-size: 14px;
        line-height: 20px;
        color: rgba($color: #ffffff, $alpha: 0.4);
        transition: color 0.2s linear;
      }
      span:nth-child(1) {
        float: left;
      }
      span:nth-child(3) {
        float: right;
        text-align: right;
      }
      .actived {
        color: #ffffff;
        transition: color 0.2s linear;
      }
    }
    .progress-bar {
      position: relative;
      width: 240px;
      height: 1px;
      background: rgba($color: #4f4f4f, $alpha: 0.4);
      border-radius: 5px;
      overflow: hidden;
    }
    .progress-line {
      position: absolute;
      width: 26px;
      top: 0;
      height: 1px;
      background: #fff;
    }
    .progress-line-0 {
      left: 1px;
      transition: left 0.4s linear;
    }
    .progress-line-1 {
      left: 107px;
      transition: left 0.4s linear;
    }
    .progress-line-2 {
      left: 213px;
      transition: left 0.4s linear;
    }
  }
  &__art {
    width: 150px;
    height: 330px;
    position: absolute;
    left: 534px;
    top: 297px;
    z-index: 10;
    border-radius: 14px;
    visibility: hidden;
    // transition: all 0.3s cubic-bezier(0.3, 0, 0.1, 1);
  }
}
.progress-line-0 {
  background: #303030;
}
.progress-line-1 {
  background: #212121;
}
.progress-line-2 {
  background: #0d0d0d;
}
.screen-motion {
  opacity: 1;
  .personality-dark__screens {
    transform: translate3d(0, 0, 0);
    transition: transform 1s linear;
  }
}
.screen-motion1 {
  .personality-dark__screens:nth-child(even) {
    transform: translate3d(0, 60px, 0);
  }
  .personality-dark__screens:nth-child(odd) {
    transform: translate3d(0, -60px, 0);
  }
}
.screen-motion2 {
  .personality-dark__screens:nth-child(even) {
    transform: translate3d(0, 120px, 0);
  }
  .personality-dark__screens:nth-child(odd) {
    transform: translate3d(0, -120px, 0);
  }
}
// 英文样式
html:not([lang|='zh-CN']) {
  .personality-dark__text {
    .progress-line-0 {
      width: 40px;
      left: 1px;
    }
    .progress-line-1 {
      width: 52px;
      left: 83px;
    }
    .progress-line-2 {
      width: 62px;
      left: 176px;
    }
    .description {
      max-width: 587px;
    }
  }
}
@media only screen and (min-width: 1950px) {
  .personality-dark__screens {
    width: 210px;
    margin-left: 39px;
  }

  .personality-dark__text {
    margin-left: 335px;
  }
  .personality-dark__screens-gentle-placeholder {
    height: 462px;
  }
  .personality-dark__art {
    width: 210px;
    height: 462px;
    left: 747px;
    top: 428px;
  }
}
@media only screen and (max-width: 1440px) {
  .personality-dark__screens--wrap {
    margin-left: -130px;
  }
  .personality-dark__text {
    margin-left: 101px;
  }
}
@media only screen and (max-width: 734px) {
  .personality-dark {
    height: auto;
    flex-direction: column-reverse;
    &__text--wrap {
      height: auto;
      margin-left: 0;
      width: auto;
      padding-right: 0;
    }
    &__text {
      padding-bottom: 0;
      width: 100%;
      margin-left: 0;
      .description {
        padding-bottom: 20px;
      }
      .progress-text {
        margin-bottom: 7px;
        width: 100%;
        span {
          width: calc(100% / 3);
          margin-right: 0;
          font-size: 16px;
          line-height: 19px;
          color: #ffffff;
          text-align: center !important;
          font-variation-settings: 'wght' 750;
        }
      }
      .progress-bar {
        width: auto;
        height: 1px;
        background: rgba($color: #fff, $alpha: 0.15);
      }
      .progress-line {
        width: calc(100% / 3) !important;
        height: 1px;
      }
      .progress-line-0 {
        left: 0 !important;
      }
      .progress-line-1 {
        left: calc(100% / 3) !important;
      }
      .progress-line-2 {
        left: calc(100% / 3 * 2) !important;
      }
    }
    &__screens--wrap {
      width: 100%;
      height: calc(100vh - 248px);
      margin: 0;
    }
    &__screens {
      width: 103px;
      margin-left: 16px;
    }
    &__screens-type {
      justify-content: center;
      height: 100%;
      width: 100%;
    }
  }
}
.dark-change-enter {
  transform: translate3d(0, 60px, 0);
}
.dark-change-enter-to {
  transform: translate3d(0, 0px, 0);
}
.dark-change-enter-active {
  transition: transform 1s linear;
}
.slide-up {
  animation-name: slide-up;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
@keyframes slide-up {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(0, -100px, 0);
  }
}
.slide-down {
  animation-name: slide-down;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
@keyframes slide-down {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(0, 100px, 0);
  }
}
</style>
